import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import('../views/HomeView'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/About',
    name: 'About',
    component: () => import('../views/About'),
  },
  {
    path: '/sxdb',
    name: 'sxdb',
    component: () => import(/* webpackChunkName: "about" */ '../views/Sxdb.vue')
  },
  {
    path: '/aggenda',
    name: 'aggenda',
    component: () => import(/* webpackChunkName: "about" */ '../views/Aggenda.vue')
  },
  {
    path: '/jointype',
    name: 'jointype',
    component: () => import(/* webpackChunkName: "about" */ '../views/JoinType.vue')
  },
  {
    path: '/sponsor',
    name: 'sponsor',
    component: () => import(/* webpackChunkName: "about" */ '../views/Sponsor.vue')
  },
  {
    path: '/exibitions',
    name: 'exibitions',
    component: () => import(/* webpackChunkName: "about" */ '../views/Exibitions.vue')
  },
  {
    path: '/mate',
    name: 'mate',
    component: () => import(/* webpackChunkName: "about" */ '../views/Mate.vue')
  },
  {
    path: '/freeticket',
    name: 'freeticket',
    component: () => import(/* webpackChunkName: "about" */ '../views/FreeTicket.vue')
  },
  {
    path: '/agenda_time',
    name: 'agenda_time',
    component: () => import(/* webpackChunkName: "about" */ '../views/Agenda_time.vue')
  },
  {
    path: '/hyticket',
    name: 'hyticket',
    component: () => import(/* webpackChunkName: "about" */ '../views/HyTicket.vue')
  },
  {
    path: '/lunbo',
    name: 'lunbo',
    component: () => import(/* webpackChunkName: "about" */ '../views/lunbo.vue')
  },
  {
    path: '/lunbo2',
    name: 'lunbo2',
    component: () => import(/* webpackChunkName: "about" */ '../views/lunbo2.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
})
export default router
